function V2() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        В2 Інформаційно-комунікаційна
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td>
                        В2.1 Здатність орієнтуватись в інформаційному просторі
                    </td>
                    <td>
                        В2.1.31 Основи медіаграмотності, способів та правил використання сучасного медіапростору, культури користування мережею Інтернет
                    </td>
                    <td>
                        В2.1.У1 Здійснювати пошук і критично оцінювати інформацію, оперувати нею у професійній діяльності
                    </td>
                </tr>
                <tr>
                    <td rowSpan="2">
                        В2.2 Здатність ефективно використовувати ІКТ та електронні (цифрові) освітні ресурси
                    </td>
                    <td>
                        В2.2.31 Нормативно-правове забезпечення використання ІКТ та електронних освітніх ресурсів в управлінській діяльності
                    </td>
                    <td>
                        В2.2.У1 Дотримуватися правових вимог використання електронних освітніх ресурсів в професійній діяльності
                    </td>
                </tr>
                <tr>
                    <td>
                        В2.2.32 Спеціалізоване програмне забезпечення для здійснення професійної діяльності та інформаційні системи для закладів дошкільної освіти
                    </td>
                    <td>
                        В2.2.У2 Застосовувати спеціалізоване програмне забезпечення та інформаційні системи для вирішення задач з управління закладом дошкільної освіти
                    </td>
                </tr>
                <tr>
                    <td>
                        В2.3 Здатність дотримуватись правил безпечної поведінки в цифровому середовищі
                    </td>
                    <td>
                        В2.3.31 Правила безпечної поведінки в цифровому середовищі, способів контролю контенту та реагування на ризики в цифровому середовищі
                    </td>
                    <td>
                        В2.3.У1 Дотримуватися вимог щодо безпечної поведінки та використання інструментів контролю контенту, захисту персональних даних, охорони прав інтелектуальної власності в цифровому середовищі
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {V2}